import type { BaseTranslation } from '../i18n-types';

export const reportReason = {
    spam: 'Spam',
    noOneInChat: 'No one in the chat',
    scam: 'Scam / Fraud',
    hateSpeech: 'Hate speech, bulling or violence',
    nudity: 'Content of adult nature (nudity/pornography)',
    inappropriateContent: 'Inappropriate content',
    underage: 'Underage',
    moreOneInChat: 'More than one person in the chat',
    other: 'Other Inappropriate Content',
    noOneInVideo: 'No one in the video',
    moreOneInVideo: 'More than one person in the video',
    inappropriateBehavior: 'Lack of direct interaction with the user',
    depictionOfMinors: 'Depiction of Minors',
    illegal: 'Illegal Exposure Including Non-Consensual Content',
    depictionOfAnimals: 'Depiction of Animals',
    violence: 'Violence / Abuse Including Self-Harm',
    hate: 'Harmful / Hate / Discriminating Speech',
    harassment: 'Harassment / Stalking / Threats',
    duplicateAccount: 'Duplicate account',
    autoDetectNudity: 'Nudity',
} satisfies BaseTranslation;
